import { createStore } from 'vuex';
import { ILockDesignerQuiz } from 'Vue/interfaces/LockDesignerQuiz';

export const lockDesignerStore: any = createStore({
    state: {
        quiz: {
            questions: [
                {
                    id: 'Q1_1',
                    question: 'Is your door an interior or exterior door?',
                    answers: [
                        {
                            answer: 'Interior',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'entrance',
                                    value: false,
                                },
                            ],
                            nextQuestion: 'Q2_1',
                            progressBar: 20,
                        },
                        {
                            answer: 'Exterior',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'entrance',
                                    value: true,
                                },
                            ],
                            nextQuestion: 'Q2_2',
                            progressBar: 20,
                        },
                    ],
                },
                {
                    id: 'Q2_1',
                    question:
                        'Do you currently have existing hardware or trim installed on this door?',
                    answers: [
                        {
                            answer: 'Yes',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: null,
                            nextQuestion: 'Q3_1',
                            progressBar: 40,
                        },
                        {
                            answer: 'No',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: null,
                            nextQuestion: 'Q3_3',
                            progressBar: 40,
                        },
                    ],
                },
                {
                    id: 'Q2_2',
                    question:
                        'Do you currently have existing hardware or trim installed on this door?',
                    answers: [
                        {
                            answer: 'Yes',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: null,
                            nextQuestion: 'Q3_2',
                            progressBar: 33,
                        },
                        {
                            answer: 'No',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: null,
                            nextQuestion: 'Q3_4',
                            progressBar: 38,
                        },
                    ],
                },
                {
                    id: 'Q3_1',
                    question:
                        'Which of these looks most like your door (pay special attention to your door’s edge)?',
                    answers: [
                        {
                            answer: 'Tubular',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'doorPrep',
                                    value: 'tubular',
                                },
                            ],
                            nextQuestion: 'Q4_1',
                            progressBar: 60,
                        },
                        {
                            answer: 'Mortise',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'doorPrep',
                                    value: 'mortise',
                                },
                            ],
                            nextQuestion: 'Q4_2',
                            progressBar: 60,
                        },
                    ],
                },
                {
                    id: 'Q3_2',
                    question:
                        'Which of these looks most like your door (pay special attention to your door’s edge)?',
                    answers: [
                        {
                            answer: 'Tubular',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'doorPrep',
                                    value: 'tubular',
                                },
                            ],
                            nextQuestion: 'Q5_1',
                            progressBar: 50,
                        },
                        {
                            answer: 'Mortise',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'doorPrep',
                                    value: 'mortise',
                                },
                            ],
                            nextQuestion: 'Q5_2',
                            progressBar: 67,
                        },
                    ],
                },
                {
                    id: 'Q3_3',
                    question:
                        'Which of these looks most like your door (pay special attention to your door’s edge)?',
                    answers: [
                        {
                            answer: 'Tubular',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'doorPrep',
                                    value: 'tubular',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                        {
                            answer: 'Mortise',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'doorPrep',
                                    value: 'mortise',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                        {
                            answer: 'No Holes',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'doorPrep',
                                    value: 'none',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 60,
                        },
                    ],
                },
                {
                    id: 'Q3_4',
                    question:
                        'Which of these looks most like your door (pay special attention to your door’s edge)?',
                    answers: [
                        {
                            answer: 'Tubular',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'doorPrep',
                                    value: 'tubular',
                                },
                            ],
                            nextQuestion: 'Q5_3',
                            progressBar: 56,
                        },
                        {
                            answer: 'Mortise',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'doorPrep',
                                    value: 'mortise',
                                },
                            ],
                            nextQuestion: 'Q5_2',
                            progressBar: 67,
                        },
                        {
                            answer: 'No Holes',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'doorPrep',
                                    value: 'none',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                    ],
                },
                {
                    id: 'Q4_1',
                    question: 'How large is the existing rose or plate?',
                    answers: [
                        {
                            answer: 'Small: 2&Prime; and smaller',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'escutcheon',
                                    value: 'small',
                                },
                            ],
                            nextQuestion: 'Q5_5',
                            progressBar: 80,
                        },
                        {
                            answer: 'Standard: about 2 5/8&Prime;',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'escutcheon',
                                    value: 'standard',
                                },
                            ],
                            nextQuestion: 'Q5_5',
                            progressBar: 80,
                        },
                        {
                            answer: 'Large: 5&Prime; and larger',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'escutcheon',
                                    value: 'large5',
                                },
                            ],
                            nextQuestion: 'Q5_5',
                            progressBar: 80,
                        },
                    ],
                },
                {
                    id: 'Q4_2',
                    question: 'How large is the existing rose or plate?',
                    answers: [
                        {
                            answer: 'Small: 2&Prime; and smaller',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'escutcheon',
                                    value: 'small',
                                },
                            ],
                            nextQuestion: 'Q5_5',
                            progressBar: 80,
                        },
                        {
                            answer: 'Large: 8&Prime; and larger',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'escutcheon',
                                    value: 'large8',
                                },
                            ],
                            nextQuestion: 'Q5_5',
                            progressBar: 80,
                        },
                    ],
                },
                {
                    id: 'Q5_1',
                    question: 'What type of hardware are you replacing?',
                    answers: [
                        {
                            answer: 'Handleset',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'handleset',
                                },
                            ],
                            nextQuestion: 'Q6_1',
                            progressBar: 67,
                        },
                        {
                            answer: 'LxL Plates',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'lxlPlates',
                                },
                            ],
                            nextQuestion: 'Q6_2',
                            progressBar: 75,
                        },
                        {
                            answer: 'Deadbolt',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'deadbolt',
                                },
                            ],
                            nextQuestion: 'Q7_2',
                            progressBar: 67,
                        },
                        {
                            answer: 'Keyed Entry',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'keyedEntry',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                    ],
                },
                {
                    id: 'Q5_2',
                    question: 'What type of hardware are you replacing?',
                    answers: [
                        {
                            answer: 'Handleset',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'handleset',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                        {
                            answer: 'Knob or Lever Plates',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'knob,lever,plate',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                        {
                            answer: 'Knob or Lever Roses',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'knob,lever,rose',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                    ],
                },
                {
                    id: 'Q5_3',
                    question: 'What type of hardware are you replacing?',
                    answers: [
                        {
                            answer: 'Handleset',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'handleset',
                                },
                            ],
                            nextQuestion: 'Q7_1',
                            progressBar: 71,
                        },
                        {
                            answer: 'LxL Plates',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'lxlPlates',
                                },
                            ],
                            nextQuestion: 'Q6_1',
                            progressBar: 71,
                        },
                        {
                            answer: 'Deadbolt',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'deadbolt',
                                },
                            ],
                            nextQuestion: 'Q7_1',
                            progressBar: 71,
                        },
                        {
                            answer: 'Keyed Entry',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'keyedEntry',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'reserve,estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                    ],
                },
                {
                    id: 'Q5_5',
                    question: 'What type of hardware are you replacing?',
                    answers: [
                        {
                            answer: 'Knob',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'knob,rose',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                        {
                            answer: 'Level',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'allowedHardwareTypes',
                                    value: 'lever,rose',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                    ],
                },
                {
                    id: 'Q6_1',
                    question:
                        'What is the center to center distance between the holes?',
                    answers: [
                        {
                            answer: 'Standard: 5.5&Prime;',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'ctc',
                                    value: 'standard5.5',
                                },
                            ],
                            nextQuestion: 'Q7_1',
                            progressBar: 84,
                        },
                        {
                            answer: 'Other',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'ctc',
                                    value: 'other',
                                },
                            ],
                            nextQuestion: 'Q7_1',
                            progressBar: 84,
                        },
                    ],
                },
                {
                    id: 'Q6_2',
                    question:
                        'What is the center to center distance between the holes?',
                    answers: [
                        {
                            answer: 'Standard: 5.5&Prime;',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'ctc',
                                    value: 'standard5.5',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                        {
                            answer: 'Other',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'ctc',
                                    value: 'other',
                                },
                            ],
                            nextQuestion: 'support',
                            progressBar: 100,
                        },
                    ],
                },
                {
                    id: 'Q7_1',
                    question:
                        'Are you looking for a mechanical or electronic locks?',
                    answers: [
                        {
                            answer: 'Mechanical',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'electronic',
                                    value: 'false',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                        {
                            answer: 'Electronic',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'electronic',
                                    value: 'true',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                    ],
                },
                {
                    id: 'Q7_2',
                    question:
                        'Are you looking for a mechanical or electronic locks?',
                    answers: [
                        {
                            answer: 'Mechanical',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'electronic',
                                    value: 'false',
                                },
                            ],
                            nextQuestion: 'Q8_1',
                            progressBar: 84,
                        },
                        {
                            answer: 'Electronic',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'electronic',
                                    value: 'true',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                    ],
                },
                {
                    id: 'Q8_1',
                    question:
                        'What is the diameter of your lock bore? (You may need to remove your current knob or handle to see this)',
                    answers: [
                        {
                            answer: '2 1/8&Prime; (Standard)',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'bore',
                                    value: '2.125',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                        {
                            answer: 'Electronic',
                            answerImage: 'https://placekitten.com/300/300',
                            filtersToSet: [
                                {
                                    name: 'bore',
                                    value: '1.625',
                                },
                                {
                                    name: 'portfolio',
                                    value: 'estate',
                                },
                            ],
                            nextQuestion: 'visualize',
                            progressBar: 100,
                        },
                    ],
                },
            ],
            filters: {
                //default values
                entrance: true,
                doorPrep: 'tubular',
                escutcheon: 'standard',
                allowedHardwareTypes: 'handleset',
                portfolio: 'estate',
                ctc: 'standard5.5',
                electronic: false,
                bore: 1.625,
            },
            buttonUrl: null,
            progressBar: 0,
            tempProgressBar: 0,
            // q: {
            //     previous: {
            //         availability: false,
            //     },
            // },
        } as ILockDesignerQuiz,
    },
    mutations: {
        //When an answer is selected change the button to the nextQuestion value
        setButtonUrl(state, data) {
            state.quiz.buttonUrl = data;
        },
        //When an answer is selected set the store.state.quiz.filters properties that apply
        setFilters(state, data) {
            if (data && data.length) {
                data.forEach((filter) => {
                    if (state.quiz.filters.hasOwnProperty(filter.name)) {
                        state.quiz.filters[filter.name] = filter.value;
                    }
                });
            }
        },
        //when an answer is selected we store the progress bar value temporarily and then
        //assign its value to the component when it loads the next question.
        updateTempProgressBar(state, data) {
            state.quiz.tempProgressBar = data;
        },
        updateProgressBar(state, data) {
            state.quiz.progressBar = data;
        },
    },
    actions: {},
    getters: {},
    modules: {},
});
